import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-sm" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_checkbox, {
      "model-value": _ctx.isAll,
      label: "All",
      "onUpdate:modelValue": _ctx.selectAll
    }, null, 8, ["model-value", "onUpdate:modelValue"]),
    _hoisted_2,
    _createVNode(_component_q_checkbox, {
      "model-value": _ctx.isOnTimeline,
      label: "Timeline",
      "onUpdate:modelValue": _ctx.toggleTimeline
    }, null, 8, ["model-value", "onUpdate:modelValue"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status) => {
      return (_openBlock(), _createBlock(_component_q_checkbox, {
        key: status.value,
        "model-value": _ctx.isSelected(status.value),
        label: status.label,
        "onUpdate:modelValue": ($event: any) => (_ctx.toggleStatus(status.value))
      }, null, 8, ["model-value", "label", "onUpdate:modelValue"]))
    }), 128)),
    _createVNode(_component_q_checkbox, {
      "model-value": _ctx.isFlagged,
      label: "Flagged",
      "onUpdate:modelValue": _ctx.toggleFlagged
    }, null, 8, ["model-value", "onUpdate:modelValue"])
  ]))
}